export const translateJobStatus = (status) => {
  switch (status) {
    case 0:
      return 'خوانده نشده';
    case 1:
      return 'درحال بررسی';
    case 2:
      return 'تایید شده';
    case 3:
      return 'رد شده';
    case 4:
      return 'حذف شده';
    default:
      return '';
  }
};

export const getBgColorBadgeJobStatus = (status) => {
  switch (status) {
    case 0:
      return 'secondary.main';
    case 1:
      return 'primary.main';
    case 2:
      return 'success.dark';
    case 3:
      return 'error.main';
    case 4:
      return 'error.dark';
    default:
      return 'primary.main';
  }
};
